

// import React, { useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import TeacherLogin from './components/pages/TeacherLogin';
// import TeacherDashboard from './components/pages/Dashboard';
// import Layout from './components/common/Layout';

// // Create a simple auth context for teacher
// const TeacherAuthContext = React.createContext();

// // Custom hook to use teacher auth
// export const useTeacherAuth = () => {
//   return React.useContext(TeacherAuthContext);
// };

// // Private route component for teacher
// const TeacherPrivateRoute = ({ children }) => {
//   const location = useLocation();
//   const teacherData = JSON.parse(localStorage.getItem('teacherData'));
  
//   return teacherData ? children : <Navigate to="/teacher/login" state={{ from: location }} replace />;
// };

// function App() {
//   const [teacherData, setTeacherData] = useState(null);

//   // Login function to be called after successful authentication
//   const login = (data) => {
//     localStorage.setItem('teacherData', JSON.stringify(data));
//     setTeacherData(data);
//   };

//   // Logout function
//   const logout = () => {
//     localStorage.removeItem('teacherData');
//     setTeacherData(null);
//   };

//   return (
//     <TeacherAuthContext.Provider value={{ teacherData, login, logout }}>
//       <Router>
//         <Routes>
//           <Route path="/teacher/login" element={<TeacherLogin />} />
          
//           <Route path="/teacher" element={
//             <TeacherPrivateRoute>
//               <Layout />
//             </TeacherPrivateRoute>
//           }>
//             <Route index element={<TeacherDashboard />} />
//             {/* Add other teacher routes here as needed */}
//           </Route>

//           {/* Redirect to login by default */}
//           <Route path="*" element={<Navigate to="/teacher/login" replace />} />
//         </Routes>
//       </Router>
//     </TeacherAuthContext.Provider>
//   );
// }

// export default App;

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import TeacherLogin from './components/pages/TeacherLogin';
import TeacherDashboard from './components/pages/Dashboard';
import Layout from './components/common/Layout';
import { TeacherAuthProvider } from './components/auth/TeacherAuthContext'; // Import the provider
import TeacherAllStudents from './components/pages/TeacherAllStudents';
import UpdateClassResults from './components/pages/UpdateClassResults';
import TeacherStudentDetailsScreen from './components/pages/TeacherStudentDetailsScreen';
import UploadVideoScreen from './components/pages/UploadVideoScreen';
import UploadNotesScreen from './components/pages/UploadNotesScreen';
import CreateAssignmentScreen from './components/pages/CreateAssignmentScreen';
import AssignmentResponsesScreen from './components/pages/AssignmentResponsesScreen';
import TeacherAssignmentsScreen from './components/pages/TeacherAssignmentsScreen';
import PublishNewsScreen from './components/pages/PublishNewsScreen';
import TeacherResourcesScreen from './components/pages/TeacherResourcesScreen';
import ResourceDetailsScreen from './components/pages/ResourceDetailsScreen';
import SchoolPerformance from './components/pages/SchoolPerformance';
import PerformanceAnalysis from './components/pages/PerformanceAnalysis';
import StudentDetailedAnalysis from './components/pages/StudentDetailedAnalysis';
import AmplifiedEvents from './components/pages/AmplifiedEvents';
import AmplifiedEventDetails from './components/pages/AmplifiedEvents'; 
import Scholarships from './components/pages/Scholarships';
import ScholarshipDetails from './components/pages/ScholarshipDetails';

// Private route component for teacher
const TeacherPrivateRoute = ({ children }) => {
  const location = useLocation();
  const teacherData = JSON.parse(localStorage.getItem('teacherData'));
  
  return teacherData ? children : <Navigate to="/teacher/login" state={{ from: location }} replace />;
};

function App() {
  return (
    <TeacherAuthProvider> {/* Use the provider from TeacherAuthContext */}
      <Router>
        <Routes>
          <Route path="/teacher/login" element={<TeacherLogin />} />
          
          <Route path="/teacher" element={
            <TeacherPrivateRoute>
              <Layout />
            </TeacherPrivateRoute>
          }>
            <Route index element={<TeacherDashboard />} />
            <Route path="students" element={<TeacherAllStudents />} />
            <Route path="update-results" element={<UpdateClassResults />} />
            <Route path="student-details" element={<TeacherStudentDetailsScreen />} />
            <Route path="upload-video" element={<UploadVideoScreen />} />
            <Route path="upload-notes" element={<UploadNotesScreen />} />
            <Route path="create-assignment" element={<CreateAssignmentScreen />} />
            <Route path="assignment-responses" element={<AssignmentResponsesScreen />} />
            <Route path="assignments" element={<TeacherAssignmentsScreen  />} />
            <Route path="publish-news" element={<PublishNewsScreen  />} />
            <Route path="resources" element={<TeacherResourcesScreen   />} />
            <Route path="resource-details" element={<ResourceDetailsScreen />} />
            <Route path="school-performance" element={<SchoolPerformance />} />
            <Route path="performance-analysis" element={<PerformanceAnalysis />} />
            <Route path="student-detailed-analysis" element={<StudentDetailedAnalysis />} />
            <Route path="amplified-events" element={<AmplifiedEvents />} />
            <Route path="amplified-event-details" element={<AmplifiedEventDetails />} />
            <Route path="scholarships" element={<Scholarships />} />
            <Route path="scholarship-details" element={<ScholarshipDetails />} />


            {/* Add other teacher routes here as needed */}
          </Route>

          {/* Redirect to login by default */}
          <Route path="*" element={<Navigate to="/teacher/login" replace />} />
        </Routes>
      </Router>
    </TeacherAuthProvider>
  );
}

export default App;